module.exports = __webpack_public_path__ + "static/media/right.1fce7054.svg";